import './PromoBrandShowcase.css';
import pixlPineappleImage from '../assest/pineapple-edition-duo-prefilled-pod-kit-by-pixl.jpg';
import noSaintWhiteImage from '../assest/vaporiser-no-saint-pod-kit.jpg';
import hyolaBlueRazzImage from '../assest/blue-razz-cherry-ultra-30k-prefilled-pod-kit-by-hyola.jpg';
import ivgStrawberryImage from '../assest/strawberry-hub-pro-12-prefilled-pod-kit-by-ivg.jpg';
import justJuiceImage from '../assest/ICEDCARAMELBOX20mgR.jpg';
import pixlTopSellerImage from '../assest/blueberry-sour-raspberry-nicsalts-20mg--by-pixl.jpg';
import pixlDuoTopSellerImage from '../assest/berry-edition-duo-prefilled-pod-kit-by-pixl.jpg';
import pabloTopSellerImage from '../assest/blue-raspberry-pablo-gold-edition-17mg-nicotine-pouches.jpg';
import hyolaTopSellerImage from '../assest/hyola-pro-max-8000-prefilled-pod-kit-triple-mango.jpg';
import oxvaTopSellerImage from '../assest/oxva-xlim-3-ultra-vape-pod-kit-metal-grey.jpg';
import noSaintBanner from '../assest/no-saint-split-banner.jpg';
import pixlBanner from '../assest/vs-Pixl_Nic_salt-split_b.jpg';
import nordicBanner from '../assest/nordic-spirit-new-price-split.jpg';
import xqsBanner from '../assest/xqs-update-hp-secondary-split.jpg';
import fumiBanner from '../assest/fumi-blackcurrant-homepage-banner.jpg';
import hyolaBanner from '../assest/vs-Hyola_promax.jpg';
import pixlLogo from '../assest/Pixl-logo.png';
import pabloLogo from '../assest/pablo-logo.jpg';
import noSaintLogo from '../assest/No_Saint-logo.jpg';
import vaporessoLogo from '../assest/vaporesso-logo.png';
import skeCrystalLogo from '../assest/ske-crystal-bar-logo.jpg';
import killaLogo from '../assest/killa-logo.jpg';
import oxvaLogo from '../assest/oxva-brand-logo.jpg';
import ivgLogo from '../assest/ivg-logo.png';
import hyolaLogo from '../assest/Hyola_promax-logo.jpg';

const latestProducts = [
  {
    id: 'pineapple-edition',
    title: 'Pineapple Edition',
    subtitle: 'PIXL Duo Big Puff Device',
    image: pixlPineappleImage,
    nicotineMg: 20,
    isNew: true,
  },
  {
    id: 'white',
    title: 'White',
    subtitle: 'NO SAINT Device',
    image: noSaintWhiteImage,
    nicotineMg: 20,
    isNew: true,
  },
  {
    id: 'blue-razz-cherry',
    title: 'Blue Razz Cherry',
    subtitle: 'Hyola Ultra 30K Prefilled Pod Kit',
    image: hyolaBlueRazzImage,
    nicotineMg: 20,
    isNew: true,
  },
  {
    id: 'strawberry-hub',
    title: 'Strawberry Hub',
    subtitle: 'IVG Pro 20mg Prefilled Pod Kit',
    image: ivgStrawberryImage,
    nicotineMg: 20,
    isNew: true,
  },
  {
    id: 'iced-caramel-macchiato',
    title: 'Iced Caramel Macchiato',
    subtitle: 'Just Juice Bar Salts Nic Salt 20mg',
    image: justJuiceImage,
    nicotineMg: 20,
  },
];

const topSellers = [
  {
    id: 'blue-sour-raspberry',
    title: 'Blue Sour Raspberry',
    subtitle: 'PIXL Nic Salts 20mg',
    image: pixlTopSellerImage,
    nicotineMg: 20,
  },
  {
    id: 'berry-edition',
    title: 'Berry Edition',
    subtitle: 'PIXL Duo Big Puff Device',
    image: pixlDuoTopSellerImage,
    nicotineMg: 20,
    isNew: true,
  },
  {
    id: 'blue-raspberry',
    title: 'Blue Raspberry',
    subtitle: 'Pablo Gold Edition 17mg Nicotine Pouches',
    image: pabloTopSellerImage,
    nicotineMg: 17,
  },
  {
    id: 'triple-mango',
    title: 'Triple Mango',
    subtitle: 'Hyola Pro Max 8000 Prefilled Pod Kit',
    image: hyolaTopSellerImage,
    nicotineMg: 20,
  },
  {
    id: 'metal-grey',
    title: 'Metal Grey',
    subtitle: 'OXVA Xlim Ultra 3 Pod Kit',
    image: oxvaTopSellerImage,
    isNew: true,
  },
];

const promoItems = [
  { id: 'p1', title: 'NO SAINT Banner', image: noSaintBanner },
  { id: 'p2', title: 'PIXL Nicsalts Banner', image: pixlBanner },
  { id: 'p3', title: 'Nordic Spirit Deal Banner', image: nordicBanner },
  { id: 'p4', title: 'XQS Flavours Banner', image: xqsBanner },
  { id: 'p5', title: 'Fumi Black Currant Banner', image: fumiBanner },
  { id: 'p6', title: 'Hyola Pro Max Banner', image: hyolaBanner },
];

const brandItems = [
  { name: 'PIXL', logo: pixlLogo },
  { name: 'PABLO', logo: pabloLogo },
  { name: 'NO SAINT', logo: noSaintLogo },
  { name: 'VAPORESSO', logo: vaporessoLogo },
  { name: 'SKE CRYSTAL', logo: skeCrystalLogo },
  { name: 'KILLA', logo: killaLogo },
  { name: 'OXVA', logo: oxvaLogo },
  { name: 'IVG', logo: ivgLogo },
  { name: 'HYOLA', logo: hyolaLogo },
];

export function LatestProductsSection() {
  return (
    <section className="top-sellers" aria-label="Latest products">
      <h2 className="top-sellers__title">Latest Products</h2>
      <div className="top-sellers__grid">
        {latestProducts.map((item) => (
          <article key={item.id} className="top-sellers__card">
            <div className="top-sellers__image-wrap">
              {item.isNew && <div className="top-sellers__new">NEW</div>}
              <img src={item.image} alt={item.title} className="top-sellers__image" />
              {item.nicotineMg && (
                <div className="top-sellers__mg">
                  <span>{item.nicotineMg}</span>
                  <small>mg</small>
                </div>
              )}
            </div>

            <div className="top-sellers__content">
              <h3>{item.title}</h3>
              <p>{item.subtitle}</p>
            </div>

            <div className="top-sellers__footer">
              <a href="/" onClick={(event) => event.preventDefault()}>
                Login to see &pound;.
              </a>
              <button type="button" aria-label={`Add ${item.title}`} className="top-sellers__add-btn">
                +
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export function TopSellersSection() {
  return (
    <section className="top-sellers" aria-label="Top sellers">
      <h2 className="top-sellers__title">Top Sellers</h2>
      <div className="top-sellers__grid">
        {topSellers.map((item) => (
          <article key={item.id} className="top-sellers__card">
            <div className="top-sellers__image-wrap">
              {item.isNew && <div className="top-sellers__new">NEW</div>}
              <img src={item.image} alt={item.title} className="top-sellers__image" />
              {item.nicotineMg && (
                <div className="top-sellers__mg">
                  <span>{item.nicotineMg}</span>
                  <small>mg</small>
                </div>
              )}
            </div>

            <div className="top-sellers__content">
              <h3>{item.title}</h3>
              <p>{item.subtitle}</p>
            </div>

            <div className="top-sellers__footer">
              <a href="/" onClick={(event) => event.preventDefault()}>
                Login to see &pound;.
              </a>
              <button type="button" aria-label={`Add ${item.title}`} className="top-sellers__add-btn">
                +
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function PromoBrandShowcase() {
  return (
    <section className="promo-brand" aria-label="Promotions and brands">
      <div className="promo-grid">
        {promoItems.map((item) => (
          <article key={item.id} className="promo-card">
            <img src={item.image} alt={item.title} className="promo-card__image" />
          </article>
        ))}
      </div>

      <div className="brand-grid">
        {brandItems.map((brand) => (
          <article key={brand.name} className="brand-card">
            <img className="brand-card__logo" src={brand.logo} alt={brand.name} />
            <div className="brand-card__name">{brand.name}</div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default PromoBrandShowcase;

